export default {
	data() {
		return {
			page: 0,
			timer: null,
		};
	},
	methods: {
		scroll() {
			if (this.page === null) {
				return;
			}
			let windowHeight =
				document.documentElement.clientHeight ||
				document.body.clientHeight;
			let scrollHeight =
				document.documentElement.scrollHeight ||
				document.body.scrollHeight;
			let scrollTop =
				document.documentElement.scrollTop || document.body.scrollTop;

			if (scrollTop + windowHeight >= scrollHeight) {
				clearTimeout(this.timer);
				this.timer = setTimeout(() => {
					this.page++;

					if (this.page !== 0) {
						this.getList();
					}
				}, 500);
			}
		},
	},
	mounted() {
		window.addEventListener('scroll', this.scroll);
		this.scroll();
	},
	destroyed() {
		window.removeEventListener('scroll', this.scroll);
		this.page = 0;
	},
	activated() {
		window.addEventListener('scroll', this.scroll);
	},
	deactivated() {
		window.removeEventListener('scroll', this.scroll);
	},
};
